import { useQuery } from "@tanstack/react-query";
import { getGameHistory } from "../../../api/game-history.ts";

export function useGameHistory() {
  return useQuery({
    queryKey: ["game-history"],
    queryFn: async () => {
      return getGameHistory();
    },
  });
}
